exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".calendar_header[data-v-5216e618]{font-family:Open Sans,sans-serif;background:#efefef;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;border-left:1px solid #aaa;border-top:1px solid #aaa;border-bottom:1px solid #aaa;font-size:14px;font-weight:700}.calendar_header .header_block[data-v-5216e618]{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;width:14.28571%;min-height:40px;border-right:1px solid #aaa}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5216e618","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/parts/catalog/card/components/tabs/schedule/components/schedulecalendar/CalendarHeader.vue
// module id = 31d4cb4bdef7477dd1d1
// module chunks = 5